module.exports = __webpack_public_path__ + "dde37af0d5bfae62a6a86a6b73fd5bc1.png";